module.exports = __webpack_public_path__ + "static/media/pendant-bulb.57e3960f.jpg";